// extracted by mini-css-extract-plugin
module.exports = {"billingInfo":"OfferCardBillingInfo__billingInfo","billingInfoTitle":"OfferCardBillingInfo__billingInfoTitle"};